import {
  getCommentsForPlace,
  getCommentsForPost,
  submitComment,
} from "@/services/supabase-service";
import { Comment } from "@/types/type";
import React, { useEffect, useState } from "react";
import {
  Button,
  FlatList,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

const Comments = ({
  id,
  type,
  header,
}: {
  id: string;
  type: string;
  header?: React.JSX.Element;
}) => {
  const basicStyling = "bg-white p-3 rounded-2xl w-fill flex-row items-center";
  const [comments, setComments] = useState<Comment[]>([]);
  const [comment, setComment] = useState("");
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setRefreshing(true);
      if (type === "place") {
        const comments = await getCommentsForPlace(id, 10, 0);
        setComments(comments);
      } else if (type === "post") {
        const comments = await getCommentsForPost(id, 10, 0);
        setComments(comments);
      }
      setRefreshing(false);
    };
    if (id) fetchData();
  }, [id]);

  const loadMore = async () => {
    if (id != "" && type != "") {
      console.log(`load more for ${id} ${comments.length} ${type}`);
      if (type === "place") {
        const newcomments = await getCommentsForPlace(id, 10, comments.length);
        setComments([...comments, ...newcomments]);
      } else if (type === "post") {
        const newcomments = await getCommentsForPost(id, 10, comments.length);
        setComments([...comments, ...newcomments]);
      }
    }
  };

  const submitCommentHandler = async () => {
    console.log("submit comment " + comment);
    const commentToSend = {
      message: comment,
      place_id: undefined as string | undefined,
      post_id: undefined as string | undefined,
    };
    if (type === "place") {
      commentToSend.place_id = id;
    } else if (type === "post") {
      commentToSend.post_id = id;
    }
    const response = await submitComment(commentToSend);
    if (response) {
      const newcomment = response as Comment;
      newcomment.profile = { full_name: "me" };
      setComments([newcomment, ...comments]);
    }
  };

  return (
    <SafeAreaView className="h-full w-full">
      <FlatList
        data={comments}
        renderItem={({ item }) => (
          <View key={item.id} className="w-full p-2 ">
            <Text>
              {item.profile?.full_name} {item.created_at}
            </Text>
            <Text>{item.message}</Text>
          </View>
        )}
        keyExtractor={(item, index) => item.id?.toString() || index.toString()}
        onEndReached={loadMore}
        onEndReachedThreshold={0}
        refreshing={refreshing}
        ListFooterComponent={
          <TouchableOpacity onPress={loadMore}>
            <Text>Load More</Text>
          </TouchableOpacity>
        }
        ListHeaderComponent={
          <View>
            {header}
            <TextInput
              placeholder="Add a comment"
              className="w-full p-2 border border-gray-200 rounded-lg"
              onChangeText={(text) => setComment(text)}
            />
            <Button title="Submit" onPress={submitCommentHandler} />
          </View>
        }
        //onRefresh={handleRefresh}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    fontSize: 100,
    alignItems: "center",
    justifyContent: "center",
  },
});
export default Comments;
